import { AfterViewInit, Component, ElementRef, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { CaseService } from '../../../_types/case-service';
import { CasesServicesService } from '../../../_services/cases-services.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { ConfigurationsService } from '../../../../common/_services/configurations.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { JobsService } from '../../../_services/jobs.service';
import { TransactionsLinesService } from 'src/app/modules/transactions/_services/transactions-lines.service';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { Capability } from 'src/app/modules/common/_types/capability';
import { Case } from '../../../_types/case';
import { CasesService } from '../../../_services/cases.service';
import { AffectedsService } from '../../../_services/affecteds.service';
import { environment } from 'src/environment/environment';
import { CasesFilesService } from '../../../_services/cases-files.service';
import { CasesServicesReasonsService } from '../../../_services/cases-services-reasons.service';
import { CaseServiceReason } from '../../../_types/case-service-reason';
import moment from 'moment';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { Worker } from 'src/app/modules/workers/_types/worker';
import { Transaction } from 'src/app/modules/transactions/_types/transaction';
import { CasesServicesCausesService } from '../../../_services/cases-services-causes.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { IncidentsTypesService } from 'src/app/modules/incidents-types/_services/incidents-types.service';
import { ThirdPartiesService } from 'src/app/modules/transactions/_services/third-parties.service';
import { CaseIncident } from '../../../_types/case-incident';
import { CasesIncidentsService } from '../../../_services/cases-incidents.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ComunicationsComponent } from 'src/app/modules/comunications/communications/comunications.component';
import { WhatsAppChatComponent } from 'src/app/modules/whatsapp/chat/whatsapp-chat.component';
import { PhoneService } from 'src/app/modules/phone/_services/phone.service';
import { CaseFile } from '../../../_types/case-file';
import { CasesServicesSignaturesService } from '../../../_services/cases-services-signatures.service';
import { StringUtilsService } from 'src/app/core/services/string-utils.service';
import { CasesDetailServiceComponent } from '../service.component';
import { MaterialsService } from 'src/app/modules/materials/_services/materials.service';
import { CaseServiceMaterialsService } from '../../../_services/case-service-materials.service';

@Component({
    selector: 'app-case-service-detail',
    templateUrl: './case-service-detail.component.html',
    styleUrls: ['./case-service-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CaseServiceDetailComponent implements AfterViewInit {
  @ViewChild('op', { static: false }) public op?: OverlayPanel;
  @ViewChildren('autoGrowTextarea') autoGrowTextareas!: QueryList<ElementRef<HTMLTextAreaElement>>;
  public opImage:CaseFile | null = null;
  public hoveredImage: CaseFile | null = null;

  public caseServiceFormGroup!: RxFormGroup;  
  public incidentFormGroup!: RxFormGroup;
  public caseService: CaseService = new CaseService();
  public materials: any[] = [];
  public selectedMaterials: string[] = [];
  public allowMaterials: boolean = false;
  public case: Case = new Case();

  public workers: Worker[] = [];
  public capabilities: Capability[] = [];
  public targets: any[] = [];
  public templateId!: string;
  public allowWrite: boolean = false;
  public showSinCitarCheck: boolean = false;
  public allowDelete: boolean = false;
  public targetId: any;
  public targetAddress: string = "";

  public imagesUrl: string = environment.api_gw + 'common/files/';
  public images: any[] = [];
  public otherImages: any[] = [];

  public showCancelCaseModal: boolean = false;
  public cancelServiceReasons: any = [];
  public cancelCaseServiceReason: CaseServiceReason = new CaseServiceReason();
  public cancelServiceCauses: any = [];

  public previousDateInit: Date | null = null;
  public budgetsFromWorker: Transaction[] = [];
  public showLilnkCase: boolean = false;

  public reclamationTypes: any[] = [
    { label: 'No', value: null },
    { label: 'Reclamación propia', value: 'Itself' },
    { label: 'Reclamación externa', value: 'External' }
  ];
  public sources: any[] = [
    { name: 'Operario', id: 'Worker' },
    { name: 'Tramitador', id: 'User' },
    { name: 'Compañía', id: 'Company' }
  ]
  public thirdParties: any[]=[];
  public incidentTypes: any[] = [];

  public incident : CaseIncident = new CaseIncident();  
  public showIncidentInfo: boolean = false;

  //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData:any = {
    phoneNumber: null,
    callerId: null
  };
  
  constructor(
    private casesServicesService: CasesServicesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    public formValidationService: FormValidatorService,
    private workersService: WorkersService,
    private transactionService: TransactionsService,
    private filesService: FilesService,
    private capabilitiesService: CapabilitiesService,
    private casesService: CasesService,
    private affectedsService: AffectedsService,
    private casesFilesService: CasesFilesService,
    private casesServicesReasonsService: CasesServicesReasonsService,
    private jobsService: JobsService,
    private casesServicesCausesService: CasesServicesCausesService,
    private loginService: LoginService,
    private materialsService: MaterialsService,
    private caseServiceMaterialsService: CaseServiceMaterialsService,
    private incidentsTypesService: IncidentsTypesService,
    private thirdPartiesService: ThirdPartiesService,
    private caseIncidentsService: CasesIncidentsService,
    private dialogService: DialogService,
    private phoneService: PhoneService,
    private caseServiceSignatureService: CasesServicesSignaturesService,
    public stringUtils: StringUtilsService,
    private configurationsService: ConfigurationsService
  ) {
    this.caseServiceFormGroup = this.formBuilder.formGroup(CaseService) as RxFormGroup;    
    this.incident.date = new Date();
    this.incident.caseId = this.config.data.caseId;
    this.showLilnkCase = this.config.data.showLilnkCase || false;
    this.incident.source = 'Worker';
    this.incidentFormGroup = this.formBuilder.formGroup<CaseIncident>(this.incident) as RxFormGroup;
  }

  async ngOnInit() {
    let caseServiceId = this.config.data.caseServiceId;
    if (caseServiceId) {
      await this.loadCaseService(caseServiceId);
      await this.loadCapabilities();
      await this.loadCaseServiceFiles();
      if(!this.caseService.signatureId) this.loadOtherClientSignatures();
      this.loadAcceptedBudget();
    } else {
      this.caseService.caseId = this.config.data.caseId;
      this.caseServiceFormGroup.patchValue(this.caseService);
      this.loadCase();
    }

    this.loadWorkers();

    this.allowWrite = this.loginService.hasPermission("CASES_SERVICES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_SERVICES.DELETE");    
    this.allowMaterials = this.loginService.hasPermission("CASES_SERVICES.MATERIALS");
    if (this.allowMaterials) {
      await this.loadMaterials();
      if (this.caseService.id) {
        this.selectedMaterials = await this.caseServiceMaterialsService.loadMaterialIdsFor(this.caseService.id);
      }
    }
    this.scheduleResizeTextareas();
    this.loadSinCitarConfiguration();
  }

  //el check "Sin citar" solo se ofrece en los tenants que lo tengan activado
  async loadSinCitarConfiguration() {
    let filters = {
      code: new Filter(FilterOperation.equals, 'code', '', 'SIN_CITAR')
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.configurationsService.all(params));
    this.showSinCitarCheck = response.meta['total'] > 0 && response.data[0].value == 'true';
  }

  ngAfterViewInit(): void {
    this.autoGrowTextareas.changes.subscribe(() => this.scheduleResizeTextareas());
    this.scheduleResizeTextareas();
  }
/*
  async opShow(event:any, image:any) {
    this.opImage = image;
    this.op?.show(event);
  }*/

  async loadCapabilities() {
    let response = await firstValueFrom(this.capabilitiesService.all());
    this.capabilities = response.data;
  }

  async loadMaterials() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 0 },
      filter: FilterBuilder.fromObject({
        active: new Filter(FilterOperation.equals, 'active', '', true)
      }).build()
    };
    let response = await firstValueFrom(this.materialsService.all(params));
    this.materials = response.data;
  }

  async loadCaseService(caseServiceId: string) {  
    let params: IParamsCollection = {
      include: ['case.client.address', 'worker', 'cancelCaseServiceCause', 'caseNotificationNumber']
    }
    this.caseService = await firstValueFrom(this.casesServicesService.get(caseServiceId, params));

    this.previousDateInit = this.caseService.date;
    await this.loadCase();
    if (this.caseService.clientId == null && this.caseService.affectedId == null) {
      this.targetId = this.case.clientId;
      this.targetAddress = this.case.client?.address?.fullAddress!;
    }

    this.caseServiceFormGroup.patchValue(this.caseService);
    if(this.caseService.isCancelled) {
      this.caseServiceFormGroup.get('date')?.disable();
      this.caseServiceFormGroup.get('estimatedDateEnd')?.disable();
    }
    this.caseServiceFormGroup.get('workerId')?.disable();
    this.caseServiceFormGroup.get('capabilityId')?.disable();
    this.caseServiceFormGroup.get('reclamationType')?.disable();
  
    if(!this.caseService.isConfirmed){
      this.caseServiceFormGroup.get('dateStart')?.disable();
      this.caseServiceFormGroup.get('dateEnd')?.disable();
    }

    if(this.checkDisabledIfEnded(this.caseService)){
      this.caseServiceFormGroup.get('notes')?.disable();
      this.caseServiceFormGroup.get('economicNotes')?.disable();
      this.caseServiceFormGroup.get('isConfirmed')?.disable();
      this.caseServiceFormGroup.get('date')?.disable();
      this.caseServiceFormGroup.get('estimatedDateEnd')?.disable();
      this.caseServiceFormGroup.get('isUrgent')?.disable();
      this.caseServiceFormGroup.get('isGuard')?.disable();
    }

    if (this.case.client) {
      this.case.client.name = this.case.client.name + ' (Asegurado)';
      this.targets.push(this.case.client);
      this.targetId = this.case.client.id;
      this.targetAddress = this.case.client?.address?.fullAddress!;
    }

    if (this.caseService.target == "Client") {
      this.targetId = this.caseService.clientId;
      this.targetAddress = this.case.client?.address?.fullAddress!;
    }
    if (this.caseService.target == "Affected") {
      this.targetId = this.caseService.affectedId;
      //Buscamos la dirección del afectado en array de targets
      let affected = this.targets.find(target => target.id === this.caseService.affectedId);
      if (typeof affected != "undefined") {
        this.targetAddress = this.targets.find(target => target.id === this.caseService.affectedId)!.address.fullAddress;
      }
    }
    if (this.caseService.case?.client?.name) {
      this.caseService.case.client.name += ' (Asegurado)';
    }

    //si está cancelado
    if (this.caseService.cancelCaseServiceReasonId != null) {
      this.cancelCaseServiceReason = await firstValueFrom(this.casesServicesReasonsService.get(this.caseService.cancelCaseServiceReasonId, { include: ['caseServiceCause'] }));
    }
    this.scheduleResizeTextareas();
  }

  public scheduleResizeTextareas(): void {
    setTimeout(() => this.resizeAllTextareas(), 0);
  }

  private resizeAllTextareas(maxHeight: number = 320): void {
    if (!this.autoGrowTextareas) {
      return;
    }

    this.autoGrowTextareas.forEach((textareaRef) => {
      this.stringUtils.ResizeTextareaElement(textareaRef.nativeElement, maxHeight);
    });
  }

  async loadWorkers() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 1000
      }
    };
    let response = await firstValueFrom(this.workersService.all(params));
    this.workers = response.data;
  }

  async loadCase() {
    let params: IParamsCollection = {
      include: ['client.address', 'clientPolicy']
    }
    this.case = await firstValueFrom(this.casesService.get(this.caseService.caseId, params));

    await this.loadAffecteds();
  }

  async loadAffecteds() {
    let params: IParamsCollection = {
      include: ['address'],
      filter: FilterBuilder.fromObject({ caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseService.caseId) }).build()
    }
    let response = await firstValueFrom(this.affectedsService.all(params));

    this.targets = [
      ...this.targets,
      ...response.data.map(affected => ({
        ...affected,
        name: affected.name + " (Afectado)"
      }))
    ];
  }

  async loadCaseServiceFiles() {
    let params: IParamsCollection = {
      include: ['file'],
    }
    let filters: any = {
      caseServiceId: new Filter(FilterOperation.equals, "caseServiceId"),
    };

    filters.caseServiceId.value = this.caseService.id;

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesFilesService.all(params));
    this.images = response.data;
  }

  async loadOtherClientSignatures(){
    let params: IParamsCollection = {
      include: ['file']
    }
    let filters: any = {
      caseServiceId: new Filter(FilterOperation.equals, "caseServiceId"),
    };

    filters.caseServiceId.value = this.caseService.id;
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.caseServiceSignatureService.all(params));
    this.otherImages  = response.data;
  }

  async loadAcceptedBudget() {
    let paramsTransactions: IParamsCollection = {}

    let filtersTra = {
      caseId: new Filter(FilterOperation.any, "caseId", '', this.case.id),
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionType.code', '', 'ingoing_budget_worker'),
      transactionStateId: new Filter(FilterOperation.any, 'transactionState.code', '', 'accepted'),
      thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId', '', this.caseService.workerId)
    }
    paramsTransactions.filter = FilterBuilder.fromObject(filtersTra).build();
    let isBudgetRequiredCaseServices2 = await firstValueFrom(this.transactionService.all(paramsTransactions));
    this.budgetsFromWorker = isBudgetRequiredCaseServices2.data;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {

    if(!this.caseServiceFormGroup.get("isConfirmed")?.value && 
        this.caseServiceFormGroup.get("dateEnd")?.value != null){
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "No se puede cerrar el servicio si el expediente no está confirmado" });
          return;
        }

    let valid = this.formValidationService.validateForm(this.caseServiceFormGroup);
    if (valid) {
      this.caseService = Object.assign(this.caseService, this.caseServiceFormGroup.value);

      let selectedTarget = this.targets.find(target => target.id === this.targetId);

      if (typeof selectedTarget != "undefined") {
        if (selectedTarget.type == "clients") {
          this.caseService.clientId = selectedTarget.id;
          this.caseService.clientAddressId = selectedTarget.addressId;
          this.caseService.affectedId = null;
          this.caseService.affectedAddressId = null;
          this.caseService.target = "Client";
        } else {
          this.caseService.clientId = null;
          this.caseService.affectedId = selectedTarget.id;
          this.caseService.affectedAddressId = selectedTarget.addressId;
          this.caseService.clientAddressId = null;
          this.caseService.target = "Affected";
        }
      }

      //comprobar si hay una cita para ese trabajador y esa fecha.
      let other = await firstValueFrom(this.casesServicesService.checkIfOtherService(this.caseService));

      if(other) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El operario ya tiene servicios en las fechas indicadas." });
      }else{
        delete this.caseService.case;
        //la coleccion no se envia en el guardado: las relaciones se escriben aparte, por su recurso
        delete this.caseService.materials;
        let caseService: any = await firstValueFrom(this.casesServicesService.save(this.caseService));

        //solo se escriben las altas y bajas reales, para no ensuciar la auditoria de la cita.
        //se usa el id devuelto porque esta ficha tambien da de alta citas nuevas
        if (this.allowMaterials) {
          let caseServiceId = caseService?.id ?? this.caseService.id;
          if (caseServiceId) await this.caseServiceMaterialsService.syncForCaseService(caseServiceId, this.selectedMaterials);
        }

        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Cita guardada correctamente." });
        //this.dynamicDialogRef.close(this.caseService.id ? null : caseService.id);
        this.dynamicDialogRef.close(caseService);
      }
      
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }


  delete() {
    //Buscamos si tiene jobs asociados
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject({ caseServiceId: new Filter(FilterOperation.equals, "caseServiceId", "", this.caseService.id) }).build()
    }
    this.jobsService.all(params).subscribe({
      next: (response) => {
        if (response.data.length > 0) {
          this.messageService.add({ closable: true, severity: 'error', detail: "No se puede eliminar la cita, ya que tiene trabajos asociados." });
        } else {
          this.confirmationService.confirm({
            message: "¿Está seguro que desea eliminar la cita?",
            header: "Eliminar cita",
            acceptLabel: "Aceptar",
            rejectLabel: "Cancelar",
            acceptButtonStyleClass: "p-button-danger",
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.casesServicesService.delete(this.caseService.id).subscribe({
                next: () => {
                  this.messageService.add({ closable: true, severity: 'success', detail: "Cita eliminada correctamente." });
                  this.dynamicDialogRef.close();
                },
                error: (error: any) => {
                  this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
                }
              });
            },
            reject: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      },
      error: (error) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

/*
  getTooltipImage(image: any): string {
    //return `<img src="${this.imagesUrl + image.fileId + '/download'}" style="height: 600px; max-width: 500px; border-radius: 5px;"/>`;
    return  `<div style="background-image: url('${this.imagesUrl + image.fileId + '/show'}');     
              width: 100%;
              height: 100%;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;"></div>`;
  }*/

  async cancelCaseModal() {
    this.showCancelCaseModal = true;
    //Cargamos los estados finales
    let params: IParamsCollection = {}
    let filters = {
      caseServiceCauseType: new Filter(FilterOperation.equals, 'caseServiceCauseType', '', 'Cancel')
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesServicesCausesService.all(params));
    this.cancelServiceCauses = response.data;
    this.cancelServiceCauses.push({ id: -1, name: "Otros" });
  }

  async cancelCaseServiceReasons($event: any) {
    this.cancelServiceReasons = [];

    this.showCancelCaseModal = true;

    //si es otro, no hacemos nada
    this.caseService.cancelCaseServiceReasonNotes = '';
    if($event.value == null || $event.value == -1) {
      this.caseService.cancelCaseServiceCauseId = null;
      this.caseService.cancelCaseServiceReasonNotes = null;
    }else{
      let params: IParamsCollection = {}
      let filters = {
        caseServiceCauseId: new Filter(FilterOperation.equals, 'caseServiceCauseId', '', $event.value)
      }
      params.filter = FilterBuilder.fromObject(filters).build();
      let response = await firstValueFrom(this.casesServicesReasonsService.all(params));
      this.cancelServiceReasons = response.data;
    }

    //añadimos opciones de otros
    this.cancelServiceReasons.push({ id: -1, name: "Otros" });

  }

  async saveCancelCaseModal(openCaseService: boolean = false) {

    if (this.caseService.cancelCaseServiceReasonId == null) {
      this.messageService.add({ closable: true, severity: 'error', detail: "Por favor seleccione el motivo de la cancelación." });
      return;
    }
    //notas minimas de 25 caracteres
    if (this.caseService.cancelCaseServiceReasonId=='-1' && this.caseService.cancelCaseServiceReasonNotes != null && this.caseService.cancelCaseServiceReasonNotes.trim().length < 25) {
      this.messageService.add({ closable: true, severity: 'error', detail: "Las notas deben tener al menos 25 caracteres." });
      return;
    }
    if (this.caseService.cancelCaseServiceReasonId == '-1') this.caseService.cancelCaseServiceReasonId = null;

    this.caseService.isCancelled = true;

    await firstValueFrom(this.casesServicesService.save(this.caseService));
    
    //Si esta el check de incidents marcado.
    if(this.showIncidentInfo){
      let valid = this.formValidationService.validateForm(this.incidentFormGroup);
      if (valid) {
        this.incident = Object.assign(this.incident, this.incidentFormGroup.value);
        let note = await firstValueFrom(this.caseIncidentsService.save(this.incident));
        if(!openCaseService) this.cancel();
        this.showCancelCaseModal = false;
      }
    }else{
      if(!openCaseService) this.cancel();
      this.showCancelCaseModal = false;
    }

    //Si marcar volver a abrir para un nuevo servicio pasando la información
    if(openCaseService){
      this.editService(this.caseService.notes)
    }
  }

async editService(notes: string = "", ) {

      let ref = this.dialogService.open(CasesDetailServiceComponent, {
        closable: true,
        modal: true,
        header: 'Planificar cita',
        width: '100%',
        height: '100%',
        contentStyle: { 'max-height': '100%', 'overflow': 'auto' },        
        data: {
          caseId: this.case.id,
          serviceId: this.caseService ? this.caseService.id : null,
          notes: notes,
          selectedCapability: this.caseService.capabilityId
        }
      });
      ref.onClose.subscribe((data: any) => {
        /*this.loadCase(this.case.id!);
        this.loadServices();*/
        this.cancel();
      });    
  }



  cancelCancelCaseModal() {
    this.caseService.cancelCaseServiceReasonId = null;
    this.caseService.cancelCaseServiceCauseId = null;
    this.caseService.cancelCaseServiceReasonNotes = undefined;

    this.showCancelCaseModal = false;
  }

  targetSelected() {
    let selectedTarget = this.targets.find(target => target.id === this.targetId);
    this.targetAddress = selectedTarget.address.fullAddress;
  }

  dateInitChanged(event: any) {
    const oldStartDate = this.previousDateInit;
    const oldEndDate = this.caseServiceFormGroup.get('estimatedDateEnd')?.value;

    if (oldStartDate && oldEndDate) {
      const diffMilliseconds = moment(oldEndDate).diff(moment(oldStartDate));
      this.caseServiceFormGroup.patchValue({
        estimatedDateEnd: moment(event).add(diffMilliseconds, 'milliseconds').toDate()
      });
    }

    this.previousDateInit = event;
  }


  downloadFile(id: any) {
    this.filesService.download(id);
  }

  onSourceChange(event: any) {
    //Cargamos los tipos de incidencia
    this.loadIncidentsType(event.value);

    //Buscamos los thirdparies
    this.loadThirdParties( event.value);
  }
  
  async loadIncidentsType(source: string){
    let params: IParamsCollection = { }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({source : new Filter(FilterOperation.equals, 'source', '', source)}).build();

    let response = await firstValueFrom(this.incidentsTypesService.all(params));
    this.incidentTypes = response.data;
    if(this.incidentTypes.length == 1) this.incidentFormGroup.patchValue({ incidentTypeId: this.incidentTypes[0].id });
  }

  async loadThirdParties(source: string) {
    let params: IParamsCollection = { }   ;
    //creamos filtros
    let filters = {
      thirdPartyType: new Filter(FilterOperation.equals, 'thirdPartyType', '', source),
      id: new Filter(FilterOperation.equals, 'id', ''),
    }

    if(source == 'Company'){
      filters.id = new Filter(FilterOperation.equals, 'id', '', this.case.companyId);
    }else if(source == 'Worker'){
      // if(this.caseServicesWorkersIds.length > 0 ) filters.id = new Filter(FilterOperation.any, 'id', '', this.caseServicesWorkersIds);
      params.page = {
        size: 1000
      };
    }

    params.filter = FilterBuilder.fromObject(filters).build();        

    let response = await firstValueFrom(this.thirdPartiesService.all(params));    
    this.thirdParties = response.data;
    // if(source == 'Worker' && this.caseServicesWorkersIds.length == 0) this.thirdParties = [];

    if(this.thirdParties.length == 1){
      this.incidentFormGroup.patchValue({ thirdPartyId: this.thirdParties[0].id });
    }else if(source == 'Worker' && this.thirdParties.length > 0){
      this.incidentFormGroup.patchValue({ thirdPartyId: this.caseService.workerId });

    }
    
  }

  async loadInfoIncident(event: any){
    this.showIncidentInfo  = event.checked;
    this.onSourceChange({value: 'Worker'});
  }

  showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId:string|undefined){
  
      this.phoneOverlayPanelData.caseService = this.caseService;
      this.phoneOverlayPanelData.phoneNumber = phoneNumber;
      this.phoneOverlayPanelData.callerId = callerId;
      this.phoneOverlayPanel?.show($event);
  }
  
  openWhatsapp(caseId:string|null = null, phoneNumber:string, name:string|null){
    //abrimos dialogo de whatsapp
    let ref = this.dialogService.open(WhatsAppChatComponent, {
      closable: true,
      modal: true,
      header: 'Whatsapp ' + phoneNumber + (name ? ' - ' + name : ''),
      width: '800px',
      draggable: true,
      data: {
        caseId: caseId,
        phoneNumber: phoneNumber,
        name: name
      }
    });
    ref.onClose.subscribe((data: any) => {
      //nothing to do
    });
  }

  addComunication(comunicationType:string|null, email:string|null, phoneNumber:string|null, attachment: boolean = false) {
    let comunicationModel:any = this.case;
    comunicationModel.caseService = this.phoneOverlayPanelData.caseService;
    let ref = this.dialogService.open(ComunicationsComponent, {
      closable: true,
      modal: true,
      header: 'Enviar comunicación',
      width: '60%',
      draggable: true,
      data: {
        caseId: this.case.id,
        model: comunicationModel,
        comunicationType: comunicationType,
        email: email,
        phoneNumber: phoneNumber,
        templateDestination: 'Case',
       // attachments: (attachment ? this.filesIdsToSend: [])
      }
    });

    ref.onClose.subscribe((data: any) => {
     // this.loadLogs(this.lastGridLogEvent);
    });
  }
  mail(email:string|undefined, caseId:string|null = null, caseServiceId:string|null = null, attachment: boolean = false){
    if(email){
     this.addComunication('Mail', email, null, attachment);
    }
  }

  sms(phoneNumber:string|undefined, caseId:string|null = null, caseServiceId:string|null = null){
    if(phoneNumber){
     this.addComunication('SMS', null, phoneNumber);
     this.phoneOverlayPanel?.hide();
    }
  }

  whatsapp(phoneNumber:string|undefined, caseId:string|null = null, callerId:string|null = null){
    if(phoneNumber){
     //this.addComunication('Whatsapp', null, phoneNumber);
     this.openWhatsapp(caseId, phoneNumber, callerId);
     this.phoneOverlayPanel?.hide();
    }
  }

  call(phoneNumber:string|undefined, callerId:string|null = null, caseId:string|null = null, caseServiceId:string|null = null){
     if(phoneNumber){
      this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
      this.phoneOverlayPanel?.hide();
     }
  }


  checkDisabledIfEnded(service:CaseService):boolean{
    return this.isRejected(service) || this.isFailed(service) || this.isCancelled(service) || this.isEnded(service);
  }

  isEnded(service:CaseService):boolean{
    return !service.isFailed && !service.isCancelled && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day' && service.dateStart!=null && service.dateEnd!=null;
  }

  isRejected(service:CaseService):boolean{
    return service.workerAttendanceStatus=='rejected' || service.workerAttendanceStatus=='rejected_day';
  }

  isFailed(service:CaseService):boolean{
    return service.isFailed && service.workerAttendanceStatus!='rejected' && service.workerAttendanceStatus!='rejected_day';
  }

  isCancelled(service:CaseService):boolean{
    return service.isCancelled;
  }
  
}
